import React from "react";
import "./Footer.scss";

export default function Footer(props) {
  return (
    <div className="footer">
      <div className="footer__copyright">© 2019 Kolawole Popoola</div>
    </div>
  );
}
